import BorderButton from "@/Component/Common/Forms/BorderButton";
import FormikTextarea from "@/Component/Common/Forms/FormikTextarea";
import FormLabel from "@/Component/Common/Forms/FormLabel";
import GradientButton from "@/Component/Common/Forms/GradientButton";
import PrimaryButton from "@/Component/Common/Forms/PrimaryButton";
import Modal from "@/Component/Common/Modal";
import { LoaderSVG } from "@/Component/Common/SVGs/CommonSVG";
import { DisputeAPI } from "@/Utils/APIRequest/Endpoints";
import { CustomToast } from "@/Utils/CustomToast";
import usePost from "@/Utils/Hooks/usePost";
import { RequiredField, YupObject } from "@/Utils/ValidationSchema";
import ValidationMsg from "@/Utils/ValidationSchema/ValidationMsg";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";

const DeclareWinnerModal = (props) => {
    const { modal, setModal, refetch } = props;

    // Patch  API
    const { isPending, mutate } = usePost(`${DisputeAPI}/solved/${modal?.id}`, null, (response) => {
        if (response?.status == 200 || response?.status == 201) {
            refetch();
            setModal(null);
            CustomToast("success", "Winner declared successfully");
        }
    }, 'patch');
    return (
        <Modal modalSize="md:w-2/4 xl:w-1/3 2xl:w-1/4" modal={modal} setModal={setModal} childMainClass="max-h-[90vh] overflow-y-auto">
            <h3 className="text-3xl font-semibold mb-5">Declare Winner</h3>
            <Formik
                enableReinitialize
                initialValues={{
                    winner: "",
                    message: "",
                    status: ""
                }}
                validationSchema={YupObject({
                    winner: RequiredField('Winner is required'),
                    message: RequiredField('Message is required'),
                    status: Yup.string().when('winner', ([winner], schema) => 
                        winner === 'brand' ? schema.required('Status is required') : schema
                    )
                })}
                onSubmit={(values: any) => {
                    values.status = values.winner == "brand" ? values.status : "closed";
                    // console.log("values", values);
                    mutate(values);
                }}
            >
                {({ values, setFieldValue, errors }) => {
                    return (
                        <Form className="grid grid-cols-12 md:gap-y-5 gap-y-3 gap-x-3">
                            <div className="flex flex-col col-span-12">
                                <div className="relative">
                                    <div className="flex items-center gap-3">
                                        <label htmlFor='brand' className="flex-1 relative cursor-pointer">
                                            <Field type="radio" id="brand" name="winner" value="brand" className="hidden peer" onClick={(e) => setFieldValue("status", "")} />
                                            <span className='peer-checked:bg-gradient-to-br from-secondary to-primary peer-checked:text-white peer-checked:font-medium text-center border border-gray rounded-xl w-full block px-2 py-3 text-lg'>Brand</span>
                                        </label>
                                        <label htmlFor='influencer' className="flex-1 relative cursor-pointer">
                                            <Field type="radio" id="influencer" name="winner" value="influencer" className="hidden peer" />
                                            <span className='peer-checked:bg-gradient-to-br from-secondary to-primary peer-checked:text-white peer-checked:font-medium text-center border border-gray rounded-xl w-full block px-2 py-3 text-lg'>Influencer</span>
                                        </label>
                                    </div>
                                </div>
                                <ErrorMessage name="winner" component="div" render={(msg) =>
                                    <ValidationMsg errorMsg={msg} />
                                } />
                            </div>
                            {values?.winner == "brand" &&
                                <div className="flex flex-col col-span-12">
                                    <FormLabel title="Status" />
                                    <div className="relative">
                                        <div className="flex items-center gap-3">
                                            <label htmlFor='posting_deliverables' className="flex-1 relative cursor-pointer">
                                                <Field type="radio" id="posting_deliverables" name="status" value="posting_deliverables" className="hidden peer" />
                                                <span className='peer-checked:bg-gradient-to-br from-secondary to-primary peer-checked:text-white peer-checked:font-medium text-center border border-gray rounded-xl w-full block px-2 py-3 text-lg'>Posting Deliverables</span>
                                            </label>
                                            <label htmlFor='cancelled' className="flex-1 relative cursor-pointer">
                                                <Field type="radio" id="cancelled" name="status" value="cancelled" className="hidden peer" />
                                                <span className='peer-checked:bg-gradient-to-br from-secondary to-primary peer-checked:text-white peer-checked:font-medium text-center border border-gray rounded-xl w-full block px-2 py-3 text-lg'>Job Cancelled</span>
                                            </label>
                                        </div>
                                    </div>
                                    <ErrorMessage name="status" component="div" render={(msg) =>
                                        <ValidationMsg errorMsg={msg} />
                                    } />
                                </div>}
                            <div className="flex flex-col col-span-12">
                                <FormLabel title="Message" />
                                <FormikTextarea textareaProps={{ type: "text", name: "message", autoComplete: "new-email", placeholder: "Enter message", rows: 3 }} />
                                <ErrorMessage name="message" component="div" render={(msg) =>
                                    <ValidationMsg errorMsg={msg} />
                                } />
                            </div>
                            <div className="flex items-center justify-end gap-3.5 col-span-12">
                                <BorderButton buttonType="button" title="Cancel" onClick={() => setModal(false)} />
                                <PrimaryButton buttonType="submit" customClass="flex items-center justify-center gap-1.5" disabled={isPending} >
                                    Submit
                                    {isPending && <LoaderSVG />}
                                </PrimaryButton>
                            </div>
                        </Form>
                    );

                }}
            </Formik>
        </Modal>
    )
}

export default DeclareWinnerModal
